const bedc = [
	'bedc:project:create:{organizationId}',
	'bedc:project:create-simple:{organizationId}',
	'bedc:project:read',
	'bedc:project:lookup',
	'bedc:project:list',
	'bedc:project:search',
	'bedc:project:update',
] as const;

const integration = [
	'integration:project:create:{organizationId}',
	'integration:project:read',
	'integration:project:list',
	'integration:project:update',

	'integration:project:read:{organizationId}/file',
	'integration:project:create:{organizationId}/file',
	'integration:project:delete:{organizationId}/file',
] as const;

export default [...bedc, ...integration] as const;
